import React, { useCallback } from 'react';
import { I18nextProvider } from 'react-i18next';

import i18n from './i18n';
import i18nContext from './i18nContext';
import useMessages from './useMessages';

const withI18next = Comp =>
  Object.assign(
    props => {
      const { data, pageContext } = {
        data: {
          allNodeLandingPage: {
            nodes: [
              {
                drupal_internal__nid: 107,
                drupal_id: 'bbfcec45-099d-4273-80e0-fc1f55f9ea3a',
                langcode: 'en',
                default_langcode: true,
                available_translations: [
                  {
                    langcode: 'en',
                    url: '/stories',
                  },
                  {
                    langcode: 'zh-hans',
                    url: '/zh/stories',
                  },
                  {
                    langcode: 'ar',
                    url: '/ar/stories',
                  },
                  {
                    langcode: 'en-ca',
                    url: '/en-ca/stories',
                  },
                ],
                path: {
                  alias: '/stories/',
                  langcode: 'en',
                },
                internal: {
                  type: 'node__landing_page',
                },
              },
              {
                drupal_internal__nid: 107,
                drupal_id: 'bbfcec45-099d-4273-80e0-fc1f55f9ea3a',
                langcode: 'ar',
                default_langcode: false,
                available_translations: [
                  {
                    langcode: 'en',
                    url: '/stories',
                  },
                  {
                    langcode: 'zh-hans',
                    url: '/zh/stories',
                  },
                  {
                    langcode: 'ar',
                    url: '/ar/stories',
                  },
                  {
                    langcode: 'en-ca',
                    url: '/en-ca/stories',
                  },
                ],
                path: {
                  alias: '/ar/stories/',
                  langcode: 'ar',
                },
                internal: {
                  type: 'node__landing_page',
                },
              },
              {
                drupal_internal__nid: 107,
                drupal_id: 'bbfcec45-099d-4273-80e0-fc1f55f9ea3a',
                langcode: 'en-ca',
                default_langcode: false,
                available_translations: [
                  {
                    langcode: 'en',
                    url: '/stories',
                  },
                  {
                    langcode: 'zh-hans',
                    url: '/zh/stories',
                  },
                  {
                    langcode: 'ar',
                    url: '/ar/stories',
                  },
                  {
                    langcode: 'en-ca',
                    url: '/en-ca/stories',
                  },
                ],
                path: {
                  alias: '/en-ca/stories/',
                  langcode: 'en-ca',
                },
                internal: {
                  type: 'node__landing_page',
                },
              },
              {
                drupal_internal__nid: 233,
                drupal_id: 'c74d2259-8f27-4f47-8661-701657046375',
                langcode: 'en',
                default_langcode: true,
                available_translations: [
                  {
                    langcode: 'en',
                    url: '/air/configure',
                  },
                  {
                    langcode: 'zh-hans',
                    url: '/zh/configure',
                  },
                ],
                path: {
                  alias: '/air/configure/',
                  langcode: 'en',
                },
                internal: {
                  type: 'node__landing_page',
                },
              },
              {
                drupal_internal__nid: 287,
                drupal_id: '08ff78b9-9d06-4a71-b6ba-8cb96af69bab',
                langcode: 'en',
                default_langcode: true,
                available_translations: [
                  {
                    langcode: 'en',
                    url: '/company/leadership',
                  },
                  {
                    langcode: 'zh-hans',
                    url: '/zh/company/leadership',
                  },
                  {
                    langcode: 'ar',
                    url: '/ar/company/leadership',
                  },
                  {
                    langcode: 'en-ca',
                    url: '/en-ca/company/leadership',
                  },
                ],
                path: {
                  alias: '/company/leadership/',
                  langcode: 'en',
                },
                internal: {
                  type: 'node__landing_page',
                },
              },
              {
                drupal_internal__nid: 287,
                drupal_id: '08ff78b9-9d06-4a71-b6ba-8cb96af69bab',
                langcode: 'ar',
                default_langcode: false,
                available_translations: [
                  {
                    langcode: 'en',
                    url: '/company/leadership',
                  },
                  {
                    langcode: 'zh-hans',
                    url: '/zh/company/leadership',
                  },
                  {
                    langcode: 'ar',
                    url: '/ar/company/leadership',
                  },
                  {
                    langcode: 'en-ca',
                    url: '/en-ca/company/leadership',
                  },
                ],
                path: {
                  alias: '/ar/company/leadership/',
                  langcode: 'ar',
                },
                internal: {
                  type: 'node__landing_page',
                },
              },
              {
                drupal_internal__nid: 287,
                drupal_id: '08ff78b9-9d06-4a71-b6ba-8cb96af69bab',
                langcode: 'en-ca',
                default_langcode: false,
                available_translations: [
                  {
                    langcode: 'en',
                    url: '/company/leadership',
                  },
                  {
                    langcode: 'zh-hans',
                    url: '/zh/company/leadership',
                  },
                  {
                    langcode: 'ar',
                    url: '/ar/company/leadership',
                  },
                  {
                    langcode: 'en-ca',
                    url: '/en-ca/company/leadership',
                  },
                ],
                path: {
                  alias: '/en-ca/company/leadership/',
                  langcode: 'en-ca',
                },
                internal: {
                  type: 'node__landing_page',
                },
              },
              {
                drupal_internal__nid: 296,
                drupal_id: '707b6d72-3f85-40be-a46b-b8a8bc201c6d',
                langcode: 'en',
                default_langcode: true,
                available_translations: [
                  {
                    langcode: 'en',
                    url: '/company/board',
                  },
                  {
                    langcode: 'ar',
                    url: '/ar/company/board',
                  },
                  {
                    langcode: 'en-ca',
                    url: '/en-ca/company/board',
                  },
                ],
                path: {
                  alias: '/company/board/',
                  langcode: 'en',
                },
                internal: {
                  type: 'node__landing_page',
                },
              },
              {
                drupal_internal__nid: 296,
                drupal_id: '707b6d72-3f85-40be-a46b-b8a8bc201c6d',
                langcode: 'ar',
                default_langcode: false,
                available_translations: [
                  {
                    langcode: 'en',
                    url: '/company/board',
                  },
                  {
                    langcode: 'ar',
                    url: '/ar/company/board',
                  },
                  {
                    langcode: 'en-ca',
                    url: '/en-ca/company/board',
                  },
                ],
                path: {
                  alias: '/ar/company/board/',
                  langcode: 'ar',
                },
                internal: {
                  type: 'node__landing_page',
                },
              },
              {
                drupal_internal__nid: 296,
                drupal_id: '707b6d72-3f85-40be-a46b-b8a8bc201c6d',
                langcode: 'en-ca',
                default_langcode: false,
                available_translations: [
                  {
                    langcode: 'en',
                    url: '/company/board',
                  },
                  {
                    langcode: 'ar',
                    url: '/ar/company/board',
                  },
                  {
                    langcode: 'en-ca',
                    url: '/en-ca/company/board',
                  },
                ],
                path: {
                  alias: '/en-ca/company/board/',
                  langcode: 'en-ca',
                },
                internal: {
                  type: 'node__landing_page',
                },
              },
              {
                drupal_internal__nid: 333,
                drupal_id: 'aa687351-e816-40b6-902d-cb5176d2589c',
                langcode: 'en',
                default_langcode: true,
                available_translations: [
                  {
                    langcode: 'en',
                    url: '/events',
                  },
                  {
                    langcode: 'ar',
                    url: '/ar/events',
                  },
                  {
                    langcode: 'en-ca',
                    url: '/en-ca/events',
                  },
                ],
                path: {
                  alias: '/events/',
                  langcode: 'en',
                },
                internal: {
                  type: 'node__landing_page',
                },
              },
              {
                drupal_internal__nid: 333,
                drupal_id: 'aa687351-e816-40b6-902d-cb5176d2589c',
                langcode: 'ar',
                default_langcode: false,
                available_translations: [
                  {
                    langcode: 'en',
                    url: '/events',
                  },
                  {
                    langcode: 'ar',
                    url: '/ar/events',
                  },
                  {
                    langcode: 'en-ca',
                    url: '/en-ca/events',
                  },
                ],
                path: {
                  alias: '/ar/events/',
                  langcode: 'ar',
                },
                internal: {
                  type: 'node__landing_page',
                },
              },
              {
                drupal_internal__nid: 333,
                drupal_id: 'aa687351-e816-40b6-902d-cb5176d2589c',
                langcode: 'en-ca',
                default_langcode: false,
                available_translations: [
                  {
                    langcode: 'en',
                    url: '/events',
                  },
                  {
                    langcode: 'ar',
                    url: '/ar/events',
                  },
                  {
                    langcode: 'en-ca',
                    url: '/en-ca/events',
                  },
                ],
                path: {
                  alias: '/en-ca/events/',
                  langcode: 'en-ca',
                },
                internal: {
                  type: 'node__landing_page',
                },
              },
            ],
          },
        },
        pageContext: {
          lng: 'ar',
          languageUrls: {
            en: '/[...]/',
            ar: '/ar/[...]/',
            'en-ca': '/en-ca/[...]/',
          },
        },
      };
      const lng =
        location.pathname.split('/')[1] !== 'commerce'
          ? location.pathname.split('/')[1]
          : 'en';
      const messages = useMessages(lng);

      const activateLng = useCallback(() => {
        if (!i18n.hasResourceBundle(lng, 'messages')) {
          i18n.addResourceBundle(lng, 'messages', messages, true);
        }
        i18n.changeLanguage(lng);
      }, [messages, lng]);

      const getLanguageUrls = useCallback(() => {
        const languageUrls = {};
        if (data?.languageUrls) {
          data.languageUrls.nodes.forEach(node => {
            languageUrls[node.langcode] = node.path.alias;
          });
        }

        if (
          Object.entries(languageUrls).length === 0 &&
          pageContext.languageUrls
        ) {
          return pageContext.languageUrls;
        }

        return languageUrls;
      }, [data, pageContext]);

      const getAlternateUrls = useCallback(() => {
        const languageUrls = {};
        if (
          Object.entries(languageUrls).length === 0 &&
          pageContext.languageUrls
        ) {
          return pageContext.languageUrls;
        }
        return languageUrls;
      }, [data, pageContext]);

      // Activate language on first and subsequent rerenders.
      activateLng();

      return (
        // we should be able to get this context in sub-components of this render tree.
        <I18nextProvider i18n={i18n}>
          <i18nContext.Provider
            value={{
              lng,
              languageUrls: getLanguageUrls(),
              direction: i18n.dir(),
              alternateUrls: getAlternateUrls(),
            }}
          >
            <Comp {...props} lng={lng} />
          </i18nContext.Provider>
        </I18nextProvider>
      );
    },
    { displayName: 'withI18next' }
  );

export default withI18next;
